<template>
  <section id="PartyAreas">
    <div id="PartyAreas-selector"></div>
    <div class="overlay"></div>
    <b-container>
      <div class="title">
        <div class="bold">Exclusive</div>
        Party Areas
      </div>
      <div class="divider" />
      <div class="area-description">
        Host your group in a private space at Globe Life Field where you pair
        amazing ballpark views with food & beverage packages to fit for your
        needs.
      </div>
      <a v-scroll-to="{ el: '#BookSuite', offset: -80 }" class="book-now"
        >Book Now</a
      >
      <SelectSeatingArea
        :seatingData="seatingData"
        :seatingSection="'party'"
        v-if="windowWidth > 992"
      />
      <SelectSeatingAreaMobile
        :seatingData="seatingData"
        :seatingSection="'party'"
        v-else
      />
    </b-container>
  </section>
</template>

<script>
import SelectSeatingArea from "@/components/global/SelectSeatingArea";
import SelectSeatingAreaMobile from "@/components/global/SelectSeatingAreaMobile";
import { partyAreasData } from "@/data/partyAreas.js";

export default {
  name: "PartyAreas",
  components: {
    SelectSeatingArea,
    SelectSeatingAreaMobile,
  },
  data() {
    return {
      seatingData: partyAreasData(),
      windowWidth: null,
    };
  },
  mounted() {
    this.windowWidth = window.innerWidth;

    window.addEventListener(
      "resize",
      () => {
        this.windowWidth = window.innerWidth;
      },
      false
    );
  },
};
</script>

<style lang="scss" scoped>
#PartyAreas {
  position: relative;
  // background-image: url("~@/assets/images/backgrounds/bg_exclusive-party-areas-2.jpeg");
  background-image: url("~@/assets/images/backgrounds/groups_lockout_exclusive-party-areas.jpeg");
  background-size: cover;
  background-repeat: no-repeat;
  margin-top: 25px;
  padding: 90px 0 140px 0;
  @media (max-width: $lg) {
    background-image: url("~@/assets/images/backgrounds/mobile-bg.jpg");
    background-position: bottom;
  }
  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: linear-gradient(
      270deg,
      rgba(4, 12, 24, 0) 0%,
      rgba(4, 12, 24, 0.9) 100%
    );
    @media (max-width: $lg) {
      background-color: rgba(4, 12, 24, 0.8);
    }
  }
  .container {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 2;
  }
  .title {
    display: flex;
    flex-direction: column;
    font-family: BertholdCondensed;
    font-size: 40px;
    line-height: 32px;
    letter-spacing: 0;
    text-transform: uppercase;
    color: #ffffff;
    .bold {
      font-weight: 700;
    }
  }
  .divider {
    height: 2px;
    width: 70px;
    background-color: #ffffff;
    margin: 10px 0 24px 0;
  }
  .area-description {
    font-family: Gotham;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0;
    text-align: center;
    color: #ffffff;
    max-width: 393px;
  }
  .book-now {
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: Gotham;
    font-weight: 900;
    font-size: 13px;
    line-height: 15px;
    letter-spacing: 0;
    color: #ffffff;
    text-transform: uppercase;
    text-decoration: none;
    width: 120px;
    height: 40px;
    border-radius: 8px;
    background-color: #c10230;
    margin: 24px 0 50px 0;
    cursor: pointer;
  }
}
</style>
